import type { DehydratedState, VueQueryPluginOptions } from '@tanstack/vue-query'
import { VueQueryPlugin, QueryClient, hydrate, dehydrate } from '@tanstack/vue-query'

declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__: import('@tanstack/query-core').QueryClient
  }
}

export default defineNuxtPlugin({
  name: 'tanstack',
  dependsOn: ['shared-components-plugin'],
  setup: (nuxt) => {
    const vueQueryState = useState<DehydratedState | null>('vue-query')
    const { public: config } = useRuntimeConfig()
    const staleTime = config.tanstackStaleTime
      ? Number(config.tanstackStaleTime)
      : nuxt.$sharedComponentsOptions?.options?.tanstack?.staleTime
    // Modify your Vue Query global settings here
    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          staleTime,
          throwOnError: !!config.throwOnError,
          retry: (count, error) => {
            if (count > 2 || error.statusCode === 404) {
              return false
            }
            return true
          },
        },
      },
    })

    const options: VueQueryPluginOptions = { queryClient }

    nuxt.vueApp.use(VueQueryPlugin, options)

    if (import.meta.server) {
      nuxt.hooks.hook('app:rendered', () => {
        vueQueryState.value = dehydrate(queryClient)
      })
    }
    if (import.meta.client) {
      if (import.meta.env.DEV) {
        // This code is for all users
        window.__TANSTACK_QUERY_CLIENT__ = queryClient
      }
      nuxt.hooks.hook('app:created', () => {
        hydrate(queryClient, vueQueryState.value)
      })
    }
  },
})
